import * as React from 'react';
import CameraUploader from './CameraDocs';
import { Button } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from "moment"
import { downloadFile, deleteFile, showfile } from "../api/files"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function FileList({ initDocs, onDocsUpdated, category, blockDelete }) {

    const [docs, setDocs] = React.useState(initDocs || []);
    const [loading, setLoading] = React.useState(false);

    async function download(id, type) {
        try {
            setLoading(true);
            const result = await downloadFile(id);
            showfile(result, type);
        } finally {
            setLoading(false);
        }
    }

    async function onDeleteFile(id) {
        try {
            const proceed = confirm(`Confermi la cancellazione del PDF del collaudo?`);
            if (!proceed) {
                return;
            }
            setLoading(true);
            await deleteFile(id);
            const updtDocs = docs.filter(file => file.id !== id);
            setDocs(updtDocs);
            if (!onDocsUpdated) return;
            await onDocsUpdated(updtDocs);
        } finally {
            setLoading(false);
        }
    }

    async function fileUploaded(file) {
        const updtDocs = docs.concat(file);
        setDocs(updtDocs);
        if (!onDocsUpdated) return;
        await onDocsUpdated(updtDocs);
    }

    function formatBytes(a, b = 2) { if (0 === a) return "0 Bytes"; const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024)); return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d] }

    return (

        <DataTable
            value={docs}
            responsive
            autoLayout={false}
            className="p-datatable-hoverable-rows p-datatable-customers"
            emptyMessage={() => (<div className="text-center">Nessun file o immagine in tabella</div>)}
            header={
                onDocsUpdated ? (
                    <div className="p-clearfix" style={{ lineHeight: '1.87em' }} tooltip="Aggiungi documento">
                        <CameraUploader
                            style={{ float: 'right' }}
                            tooltip={'Aggiungi nuova immagine'}
                            path={category}
                            onFileUploaded={fileUploaded}
                        />
                    </div>
                ) : null
            }
        >
            <Column
                field="filename"
                header="File"
                style={{ wordWrap: 'break-word' }}
            />
            <Column
                field="size"
                header="Dimensione"
                style={{ wordWrap: 'break-word' }}
                body={(row) => formatBytes(row.size)}
            />
            <Column
                field="finished_at"
                header="Caricato il"
                style={{ wordWrap: 'break-word' }}
                body={(row) => moment(row.finished_at).format("DD/MM/YYYY HH:mm")}
            />

            <Column
                style={{ wordWrap: 'break-word', textAlign: 'center' }}
                body={file => (
                    <div>
                        {blockDelete(file.filename) && (
                            <Button
                                disabled={loading}
                                color="success"
                                onClick={() => download(file.id, file.filename.endsWith('.pdf') ? 'application/pdf' : undefined)}
                                style={{ marginRight: '.5em' }}
                            >
                                <FontAwesomeIcon icon="file-pdf" />
                            </Button>
                        )}
                        {!blockDelete(file.filename) && (
                            <Button
                                disabled={loading}
                                color="secondary"
                                onClick={() => download(file.id, file.filename.endsWith('.pdf') ? 'application/pdf' : undefined)}
                                style={{ marginRight: '.5em' }}
                            >
                                <FontAwesomeIcon icon="image" />
                            </Button>
                        )}
                        {onDocsUpdated && !blockDelete(file.filename) && (
                            <Button
                                disabled={loading}
                                color="danger"
                                onClick={() => onDeleteFile(file.id)}
                            >
                                <FontAwesomeIcon icon="trash-alt" />
                            </Button>
                        )}
                    </div>
                )}
            />
        </DataTable>

    );
}
